import { LogLevel } from '@azure/msal-browser'

const runtimeConfig = window && (window as any).authConfig

export const msalConfig = {
  auth: {
    clientId: runtimeConfig?.clientId ?? import.meta.env.VITE_AAD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${
      runtimeConfig?.tenantId ?? import.meta.env.VITE_AAD_TENANT_ID
    }`,
    redirectUri: import.meta.env.BASE_URL // Automatically picks up the path this app is served from
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: string, containsPii: any) => {
        if (containsPii) {
          return
        }
        switch (level) {
          /* eslint-disable no-console */
          /* tslint:disable:no-console */
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            if (import.meta.env.DEV)
              // Skip info messages in production
              console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)

          /* tslint:enable:no-console */
          /* eslint-enable no-console */
        }
      }
    }
  }
}

// Can be found in the API Permissions of the ASP.NET Web API
export const apiTokenRequest = {
  scopes: ['api://qhub-absa-api/Data.Read']
}
